export default {
   'floorplanGuide': '沙盘图',
   'floorplanGuideTips': '一键点击展位导航',
   'liveStream': '参展商直播',
   'featuredExhibitors': '特色展商',
   'bookingNow': '进入',
   'distanceFromLiveTime': {
      'time':'开播时间',
      'noStart':'已开播'
   },
   'viewProductLive':'浏览更多展品',
   'viewMoreLive':'观看更多直播',
   'exhTips':'多个供应商的快速报价',
   'youMayLike':'你可能喜欢',
   'concurrentEvents': '同期活动',
   'footerTitle1':'晋江鞋体（线上）博览会',
   'footerTitle2':'快速链接:',
   'footerTitle3':'主办单位:',
   'footerTitle4':'2022年4月19日-22日',
   'footerTitle5':'欢迎前往',
   'footerTitle6':'海外社交媒体',
   

   'footerQuickAccess1':'在线展厅',
   'footerQuickAccess2':'关于锦汉',
   'footerQuickAccess3':'如何到达',
   'footerQuickAccess4':'下载中心',
   'footerQuickAccess5':'隐私保护',
   'footerQuickAccess6':'站点地图',
   'newText1': '3D展位图',
   'newText2': '新闻中心',
   'newText3': '关于锦汉',
   'newText4': '联系我们',
   'newText5': '相关知识产权',
   'newText6':'APP 操作指南',
   'newText7':'网站操作指南',
   'footerComName':'广州市保利锦汉展览有限公司',
   'footerFax':'传真 : (86-595)-85674572',
   'footerTel':'电话 : (86-595)-85600609',
   'footerEmail':'邮箱 : jif@cn-jif.com',
   'footerAddress':'地址 : 福建省晋江市梅岭路西侧残疾人服务中心七层',
   'footerAddressTips':'（广交会C区B区对面）',
   'footerSocialMedia':'社交媒体',
   'exhibitor':'展商',
   'person':'客商',
   'Home': '首页',
   'Exhibitor': '找展商',
   'Products': '找展品',
   'Visitor':'找客商',
   'Business':'找商机',
   'Live':'直播',
   'About':'关于',
   'QA':'Q&A',
   'News': '新闻',
   'viewMoreNews': '浏览更多新闻',

   'download':'微信公众号',
   'searchPlaceHolder': '搜索',
   '晋江贸促会': '晋江市贸促会',
   '国际商会': '(国际商会)',
   '公众号': '公众号',
   "purchaseMeeting": "采购对接会",

   '主办单位': "主办单位:",
   '中华人民共和国科学技术部': "中华人民共和国科学技术部",
   '中华人民共和国国家知识产权局': "中华人民共和国国家知识产权局",
   '中国国际贸易促进委员会': "中国国际贸易促进委员会",
   '北京市人民政府': "北京市人民政府"   


}
  